import { PropsWithChildren } from 'react'

import { useLexicalEditable } from '@lexical/react/useLexicalEditable'
import { Divider } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { DeleteNodeButton } from '../../../components/DeleteButton'
import { ToolbarContainer } from '../../ToolbarContainer'
import { useImageCardStore } from '../Store/hooks/useStore'

import { AlignDropdown } from './AlignDropdown'
import { DescButton } from './DescButton'
import { LinkDropdown } from './LinkDropdown'
import { RotateButton } from './RotateButton'
import { SizeDropdown } from './SizeDropdown'
import { StyleDropdown } from './StyleDropdown'

export const ImageToolbar = ({ children }: PropsWithChildren) => {
  const { toolbarRef, active, nodeKey } = useImageCardStore(state =>
    pick(state, ['toolbarRef', 'active', 'nodeKey'])
  )

  const editable = useLexicalEditable()

  if (!editable) {
    return children
  }

  return (
    <ToolbarContainer open={active} triggerNode={children}>
      <div
        ref={toolbarRef}
        role='button'
        tabIndex={-1}
        onClick={e => e.stopPropagation()}
        onPointerDown={e => e.stopPropagation()}
      >
        <RotateButton />
        <SizeDropdown />
        <Divider orientation='vertical' />
        <LinkDropdown />
        <DescButton />
        <Divider orientation='vertical' />
        <AlignDropdown />
        <StyleDropdown />
        <Divider orientation='vertical' />
        <DeleteNodeButton nodeKey={nodeKey} />
      </div>
    </ToolbarContainer>
  )
}
